import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import TermsAgreementModal from "@/components/TermsAgreementModal";
import { useAppInitQuery, useAuthSelectProfileMutation, useLoginTermsLazyQuery, useModal } from "@/hooks";
import config from "@/lib/config";
import { ADULT_RESTRICTION_AGE } from "@/lib/constants";
import notAgreementTermsFilter from "@/lib/notAgreementTermsFilter";
import routes from "@/lib/routes";
import { useRouter } from "next/router";
import { useEffect, useMemo, useState } from "react"; // Appの初期化処理をする

import { jsx as _jsx } from "react/jsx-runtime";
export function useAppInit() {
  var router = useRouter();

  var _useState = useState({
    selectedProfile: undefined,
    disabledAccess: false
  }),
      state = _useState[0],
      setState = _useState[1];

  var _useModal = useModal(),
      showModal = _useModal.showModal;

  var _useAuthSelectProfile = useAuthSelectProfileMutation(),
      _useAuthSelectProfile2 = _slicedToArray(_useAuthSelectProfile, 1),
      selectedProfileMutation = _useAuthSelectProfile2[0];

  var _useLoginTermsLazyQue = useLoginTermsLazyQuery(),
      _useLoginTermsLazyQue2 = _slicedToArray(_useLoginTermsLazyQue, 2),
      getLoginTerms = _useLoginTermsLazyQue2[0],
      termsData = _useLoginTermsLazyQue2[1].data;

  var _useAppInitQuery = useAppInitQuery({
    fetchPolicy: "cache-first"
  }),
      appLoading = _useAppInitQuery.loading,
      data = _useAppInitQuery.data;

  var user = data === null || data === void 0 ? void 0 : data.user;
  var adultMode = data === null || data === void 0 ? void 0 : data.adultMode;
  var deviceInfo = data === null || data === void 0 ? void 0 : data.deviceInfo;
  var loading = useMemo(function () {
    // ロード済みでユーザーがない（未ログイン）場合はプロフィールの選択状況は見ない
    if (!appLoading && !user) {
      return false;
    }

    return appLoading || typeof state.selectedProfile === "undefined";
  }, [state.selectedProfile, appLoading, user]);
  useEffect(function () {
    // アプリから参照されるページ、クローラーは海外判定しない
    if (deviceInfo && !(deviceInfo !== null && deviceInfo !== void 0 && deviceInfo.isBot) && !~router.asPath.indexOf("/app/static") && router.asPath !== routes.geoRestriction) {
      fetch(config.ipCheckURL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        }
      }).then(function (res) {
        return res.json();
      }).then(function (res) {
        if (!res.accessibility) {
          window.location.href = routes.geoRestriction;
        }
      });
    }
  }, [deviceInfo]);
  useEffect(function () {
    if (user) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        PaidOTTmemberId: user.hashedUserId
      });
    }
  }, [user]);
  useEffect(function () {
    var getTermTimeoutId;

    if (!appLoading) {
      var disabled = false;
      var selected = true;

      if (user) {
        if (adultMode && user.age < ADULT_RESTRICTION_AGE) {
          disabled = true;
        } // プロフィールが1つしかなかったら自動で選択する


        if (!user.currentProfile && !disabled) {
          if (user.profiles.length == 1) {
            var profile = user.profiles[0];

            if (!profile.needPasscode) {
              selectedProfileMutation({
                variables: {
                  profileId: parseInt(profile.id, 10)
                }
              });
              selected = true;
            } else {
              selected = false;
            }
          } else {
            selected = false;
          }
        } // 規約の同意状況を取得


        if (user.currentProfile && !disabled) {
          getTermTimeoutId = setTimeout(function () {
            getLoginTerms({
              variables: {
                adult: adultMode
              },
              fetchPolicy: "network-only"
            });
          }, 100);
        }
      }

      setState({
        selectedProfile: selected,
        disabledAccess: disabled
      });
    }

    return function () {
      clearTimeout(getTermTimeoutId);
    };
  }, [appLoading, user, adultMode]);
  useEffect(function () {
    if (user && termsData && !~router.asPath.indexOf("/static/legal") && !router.asPath.includes("/signup") && !router.asPath.includes("/logout")) {
      // 規約の同意状況をチェックする
      fetch("/api/optional_terms").then(function (res) {
        return res.json();
      }).then(function (_ref) {
        var confirm = _ref.confirm;
        var filterdTerms = notAgreementTermsFilter([].concat(_toConsumableArray(termsData.required), _toConsumableArray(termsData.optional)), !confirm);

        if (filterdTerms.length > 0) {
          var required = filterdTerms.find(function (term) {
            return term.required;
          });
          var optional = filterdTerms.find(function (term) {
            return !term.required;
          });
          showModal( /*#__PURE__*/_jsx(TermsAgreementModal, {
            terms: filterdTerms
          }), {
            closeButton: !required,
            outerAreaClose: !required,
            style: "termsAgreementModal"
          });
          return {
            viewOptionalTerms: !!optional
          };
        } else {
          return {
            viewOptionalTerms: false
          };
        }
      }).then(function (_ref2) {
        var viewOptionalTerms = _ref2.viewOptionalTerms;

        if (viewOptionalTerms) {
          fetch("/api/optional_terms", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              confirm: true
            })
          });
        }
      });
    }
  }, [user, termsData, router.asPath]);
  useEffect(function () {
    var authIntervalId;

    var authCheck = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetch("/api/auth_check?ts=".concat(+new Date())).then(function (res) {
                  return res.json();
                });

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function authCheck() {
        return _ref3.apply(this, arguments);
      };
    }();

    var startInterval = function startInterval() {
      // ページを放置したときにトークンのexpireが切れないように60分ごとにリクエストする
      clearInterval(authIntervalId);
      authIntervalId = setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return authCheck();

              case 2:
                return _context2.abrupt("return", _context2.sent);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })), 60 * 60 * 1000);
    };

    var onBlur = function onBlur() {
      clearInterval(authIntervalId);
    };

    var onFocus = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return authCheck();

              case 2:
                startInterval();

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function onFocus() {
        return _ref5.apply(this, arguments);
      };
    }();

    if (user) {
      window.addEventListener("blur", onBlur);
      window.addEventListener("focus", onFocus);
      startInterval();
    }

    return function () {
      clearInterval(authIntervalId);
      window.removeEventListener("blur", onBlur);
      window.removeEventListener("focus", onFocus);
    };
  }, [user]);
  return _objectSpread(_objectSpread({
    loading: loading,
    user: user
  }, state), {}, {
    adultMode: adultMode,
    deviceInfo: deviceInfo
  });
}